import styles from './ActionRequiredAlertDetales.module.scss';
import { ReactComponent as IconAlert } from '../OrdersContent/img/iconAlert2.svg';

interface ActionRequiredAlertDetalesProps {
  dateStr: string;
}

export const ActionRequiredAlertDetales: React.FC<ActionRequiredAlertDetalesProps> = ({
  dateStr,
}) => {
  const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;

  const year = match[1];
  const monthNum = parseInt(match[2], 10);
  const day = parseInt(match[3], 10);

  const months = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ];
  const monthName = months[monthNum - 1];

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.header_left}>
          <IconAlert />
          <div className={styles.header_text}>
            <span className={styles.header_title}>Чек был аннулирован</span>
            <div className={styles.body}>
              <span>
                {' '}
                Дата аннулирования чека {day} {monthName} {year} года
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
